module.exports = __webpack_public_path__ + "static/media/delivered-orders.02c94dad.svg";